const ActiveBorder = '2px solid #0C7C84';
const ActiveHoverBorder = '2px solid #16B9D4';
const DisabledBorder = '2px solid #BDBDBD';
const InactiveBorder = '2px solid #757575';
const InactiveHoverBorder = '2px solid #16B9D4';

function getBorder({
  disabled,
  active,
  focus,
}) {
  if (disabled) {
    return DisabledBorder;
  }

  if (active) {
    return focus ? ActiveHoverBorder : ActiveBorder;
  } else {
    return focus ? InactiveHoverBorder : InactiveBorder;
  }
}

export default {
  activeLabelStyle: {
    color: '#FFFFFF',
    fontSize: '16px',
    fontWeight: '500',
    textTransform: 'uppercase',
  },
  container: {
    calculate: ({
      disabled,
      usingLabels,
    }) => {
      let style = {
        display: 'inline-flex',
        width: usingLabels ? '68px' : '56px',
      };

      if (disabled) {
        style.cursor = 'default';
      }

      return style;
    },
  },
  colors: {
    activeThumb: {
      calculate: ({
        disabled,
      }) => {
        return {
          base: disabled ? '#EEEEEE' : '#FFFFFF',
        };
      }
    },
    inactiveThumb: {
      calculate: ({
        disabled,
      }) => {
        return {
          base: disabled ? '#EEEEEE' : '#FFFFFF',
        };
      }
    },
    active: {
      calculate: ({
        disabled,
        focus,
      }) => {
        return {
          base: disabled ? '#BDBDBD' : focus ? '#16B9D4' : '#0C7C84',
          hover: disabled ? '#BDBDBD' : '#16B9D4',
        };
      }
    },
    inactive: {
      calculate: ({
        disabled,
        focus,
        inactiveTrackColor,
      }) => {
        return {
          base: disabled ? '#EEEEEE' : focus ? '#E4F9F9' : inactiveTrackColor,
          hover: disabled ? '#EEEEEE' : '#E4F9F9',
        };
      }
    },
  },
  disabledThumbIcon: {
    color: '#BDBDBD',
    display: 'block',
    fontSize: '29px',
    marginTop: '-9px',
    marginLeft: '3px',
    transform: 'rotate(-45deg)',
  },
  inactiveLabelStyle: {
    calculate: ({
      disabled,
      focus,
    }) => {
      return {
        color: disabled ? '#BDBDBD' : focus ? '#16B9D4' : '#757575',
        fontSize: '16px',
        fontWeight: '500',
        textTransform: 'uppercase',
      };
    }
  },
  inactiveLabelStyleHover: {
    calculate: ({
      disabled,
    }) => {
      return {
        color: disabled ? '#BDBDBD' : '#16B9D4',
      };
    }
  },
  thumb: {
    calculate: ({
      disabled,
      active,
      focus,
    }) => {
      return {
        border: getBorder({
          disabled,
          active,
          focus,
        }),
        boxShadow: 'none',
        height: '27px',
        width: '27px',
      };
    },
    hover: {
      calculate: ({
        active,
        disabled,
      }) => {
        return {
          border: getBorder({
            active,
            disabled,
            focus,
          }),
        };
      },
    }
  },
  track: {
    calculate: ({
      active,
      disabled,
      focus,
      usingLabels,
    }) => {
      let styles = {
        border: getBorder({
          active,
          disabled,
          focus,
        }),
        boxShadow: 'none',
        height: '28px',
        width: usingLabels ? '68px' : '56px',
      };

      return styles;
    },
    hover: {
      calculate: ({
        active,
        disabled,
      }) => {
        return {
          border: getBorder({
            active,
            disabled,
            focus,
          }),
        };
      },
    }
  }
};